import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import Item from '../../../shared/TechSkills/Item';
import AddItem from '../../../shared/TechSkills/AddItem';
import DragNDropList from '../../../shared/DragNDropList';
import config from '../../../config';

const CiCdToolsTab = ({ data, onChange }) => {

  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');

  useEffect(() => {
    if (!('ciCdTools' in data)) {
      dispatch({
        type: 'migrate_section',
        payload: {
          key: 'ciCdTools',
          value: {
            enable: false,
            heading: 'CI/CD Tools',
            items: [],
          },
        },
      });
    }
  }, [data, dispatch]);

  return (
    'ciCdTools' in data && (
      <>
        <div className="mb23 flex justify-between items-center">
          <div className="title_tab">{t('ciCdTools.title.label')}</div>

          <div className="col-span-1">
            <Checkbox
              checked={data.ciCdTools.enable}
              onChange={v => onChange('data.ciCdTools.enable', v)}
            />
          </div>
        </div>

        <hr className="my-6" />

        <DragNDropList
          data={data}
          dispatch={dispatch}
          onChange={onChange}
          type="ciCdTools"
        >
          {data.ciCdTools.items.map((x, index) => (
            <Item
              item={x}
              key={x.id}
              index={index}
              onChange={onChange}
              dispatch={dispatch}
              first={index === 0}
              last={index === data.ciCdTools.items.length - 1}
              type='ciCdTools'
              idTab={config.TECH_SKILLS_TABS.ciCdTools}
            />
          ))}
        </DragNDropList>

        <AddItem heading={data.ciCdTools.heading} dispatch={dispatch} type='ciCdTools' idTab={config.TECH_SKILLS_TABS.ciCdTools} />
      </>
    )
  );
};

export default CiCdToolsTab;
